import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import pagesService from "../../../services/pagesService.js";
import SidebarNav from "../Sidebar/SidebarNav.js";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

const Page = () => {
    const { pageId } = useParams();
    const [page, setPage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        pagesService.getPage(pageId)
            .then(setPage)
            .catch(err => setError("Página no encontrada"));
    }, [pageId]);

    if (error) return <div className="container p-4"><h3>{error}</h3></div>;
    if (!page) return <div className="container p-4"><p>Cargando...</p></div>;

    return (
        <div className="container-fluid">
            <div className="row vh-100">
                <SidebarNav />

                <div className="p-4 content-container col-md-9 col-lg-10">
                    <h1><i className="bi bi-card-heading"></i> {page.title}</h1>
                    <div className="toastui-editor-contents" dangerouslySetInnerHTML={{ __html: page.content }} />
                </div>

            </div>
        </div>
    );
};

export default Page;
